var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#13588F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0374 30.9923L16.0276 14.0337C16.0836 13.7155 16.2018 13.4114 16.3753 13.1388C16.5489 12.8663 16.7744 12.6305 17.0391 12.4452C17.3038 12.2598 17.6023 12.1283 17.9178 12.0584C18.2333 11.9884 18.5594 11.9813 18.8777 12.0374L33.4143 14.602C34.0568 14.7154 34.6279 15.0794 35.0021 15.6138C35.3762 16.1483 35.5228 16.8095 35.4094 17.452L32.4192 34.4106C32.3632 34.7288 32.245 35.0329 32.0715 35.3055C31.8979 35.5781 31.6724 35.8138 31.4077 35.9992C31.1431 36.1846 30.8445 36.316 30.529 36.386C30.2136 36.4559 29.8874 36.4631 29.5692 36.407L15.0325 33.8423C14.3901 33.7289 13.8189 33.365 13.4448 32.8305C13.0706 32.296 12.9241 31.6348 13.0374 30.9923Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4475 17.3096L30.139 19.0181M19.5927 22.1547L29.2842 23.8645M18.739 26.9998L24.7957 28.0687",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/BookIcon.428e70ed7a6810b19e760a882118575f.svg";
export { ForwardRef as ReactComponent };